import { render, staticRenderFns } from "./SurveyManagementEditChoiceAttributes.vue?vue&type=template&id=fecdac20&scoped=true&"
import script from "./SurveyManagementEditChoiceAttributes.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementEditChoiceAttributes.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementEditChoiceAttributes.vue?vue&type=style&index=0&id=fecdac20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecdac20",
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementEditChoiceAttributes.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fecdac20')) {
      api.createRecord('fecdac20', component.options)
    } else {
      api.reload('fecdac20', component.options)
    }
    module.hot.accept("./SurveyManagementEditChoiceAttributes.vue?vue&type=template&id=fecdac20&scoped=true&", function () {
      api.rerender('fecdac20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/questions/SurveyManagementEditChoiceAttributes.vue"
export default component.exports